import { ReactElement, useEffect, useState } from 'react';
import { iInstalmentFormValues } from '@services/InstalmentService';
import { tile } from '@interfaces/interfaces';
import { FormType } from '@constants';
import { getValidFilesConfig } from '@api/index';

import { FileUploadGroup, LimitedTextAreaLarge, TextInput, TileRadioAccessible } from '@components';
import { Field, useFormikContext } from 'formik';

import styles from './InstalmentStep10.module.scss';

function InstalmentStep10(): ReactElement {
  const { values }: { values: iInstalmentFormValues } = useFormikContext();
  const context = useFormikContext();
  const [fileDescrption, setFilesDescription] = useState('You may upload a maximum of 5 files; each file should be less than 4MB.');
  const [fileSizeLimit, setFileSizeLimit] = useState('4');
  const [fileNumberLimit, setFileNumberLimit] = useState(5);
  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];

  useEffect(() => {
    const getFileInfo = async (): Promise<void> => {
      getValidFilesConfig().then((responseBody) => {
        if (responseBody) {
          const instalmentData = responseBody.find((response) => response.FormType === FormType.INSTALMENT);
          if (instalmentData?.Description) {
            setFilesDescription(instalmentData?.Description);
          }
          if (instalmentData?.FileSize) {
            setFileSizeLimit(Math.floor(instalmentData?.FileSize / 1000000).toString());
            context.setFieldValue('FileSizeLimitFinancialDocs', Math.floor(instalmentData?.FileSize / 1000000).toString());
            // INVALID_FILE_SIZE_ERROR_MESSAGE = `Sorry, this file is either too large (must be less than ${fileSizeLimit} MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.`;
          }
          if (instalmentData?.MaxAttachments) {
            setFileNumberLimit(parseInt(instalmentData.MaxAttachments, 10));
          }
        }
      });
    };
    getFileInfo();
  }, []);

  return (
    <div>
      <span className="vfH2">Your financial details</span>
      <Field
        name="haveExceptionalCircumstances"
        component={TileRadioAccessible}
        tileData={TILE_DATA}
        title="Do you have any exceptional financial circumstances you would like to let us know about?"
        orientationRow
        isMandatory
      />
      {(values.haveExceptionalCircumstances === 'true')
      && (
      <div>
        <Field
          component={LimitedTextAreaLarge}
          name="DetailsOfFinancialCircumstances"
          value={values.DetailsOfFinancialCircumstances}
          limit={3000}
          title="Provide details for any circumstances you would like to be considered in this application. Maximum 3000 characters."
          isMandatory
        />
        <p>
          Attach any supporting documents (
          {fileDescrption}
          ). If supporting documents are not provided, your application may not be successful.
          <span className={styles.optional}>(optional)</span>
        </p>
        <Field
          component={FileUploadGroup}
          uploadAReport="SupportingFinancialDocNameField"
          uploadFieldArrayName="SupportingFinancialDocuments"
          whoPrepared="SupportingFinancialDocFilesProvider"
          briefDescription="SupportingFinancialDocFilesDescription"
          fileSizeErrorField="SupportingFinancialDocFieldErrorHandle"
          fileUploadFailErrorField="SupportingFinancialDocFileUploadErrorHandle"
          UploadFileSectionError="SupportingFinancialDocUploadFileSectionError"
          fileSizelimit={fileSizeLimit}
          totalFileLimit={fileNumberLimit}
          hasPrepared={false}
          hasDescribe={false}
          formType={FormType.INSTALMENT}
          isMandatory
        />
      </div>
      )}
      {values.isDebtorTypeIndividual && <Field component={TextInput} name="numberOfDependents" title="How many dependants do you have?" type="number" orientationRow />}
    </div>
  );
}

export default InstalmentStep10;
